import React, { useEffect, useRef, useState } from "react";
import ApplyButton from "../../../containers/try2/Customization/try2Customization/ApplyButton";
import { Row } from "react-bootstrap";
import * as CONSTANT from "../../../constants";
import { useDispatch } from "react-redux";
import { kidsComboItemSelection, removeTemporarilyAddedPriceForItem, resetComboItemModifiersByItemId } from "../../../redux/slices/itemCustomizationSlice";
import { useAppSelector } from "../../../redux/store/store";
import { getModifierGroup, getCustomizedItemStack, removeItemFromItemStack, removeSelectedModifiers, selectedIngredients } from "../../../helpers/combo/kidsCombo/kidsComboHelper";
import KidsComboItemListing from "./KidsComboChoseAnItem";
import { IKidsComboModifierItem, IModifierGroups } from "../../../models/kidsCombo";
import NestedModifiersView from "./NestedModifiers";
import Scrollbars from "react-custom-scrollbars";
import kidsComboStyleClasses from "./kidsCombo.module.scss";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import ChoseItemModalContent from "./ChoseItemModalContent";
import { checkIfUserAddAllItems, checkIfUserAddSecondItemAfterOne } from "../../../helpers/customizedItem/customizedItem.helper";
import { updateAllItemAddedStateForKidsCombo } from "../../../redux/slices/itemSlice";

const ChoseItemModal = ({
  isCustomize,
  selectedItemId,
  chooseName,
  itemModifierGroups,
  handleIngredientSelection,
  setChosseItem,
  setIsCustomize,
  chooseHandleClose
}) => {
  const dispatchItem = useDispatch();
  const order = useAppSelector((state: any) => state.itemCustomization);
  const cart = useAppSelector((state) => state.cart);
  const [itemStack, setItemStack] = useState<IKidsComboModifierItem[]>([]);
  const [isCustomizing, setIsCustomizing] = useState<boolean>(isCustomize);
  const isItMobile = useCheckMobileScreen();
  let requiredItemAsModifier =
    selectedItemId < 3
      ? itemModifierGroups[0]?.modifiers_groups_modifiers
      : itemModifierGroups[1]?.modifiers_groups_modifiers;

  const modifierGroupsQueue = useRef<IModifierGroups[]>([]).current;

  const modifierGroup = getModifierGroup(itemStack?.[itemStack.length - 1], modifierGroupsQueue);
  
  requiredItemAsModifier =
    itemStack?.length && Object.keys(modifierGroup)?.length
      ? itemStack
      : requiredItemAsModifier;


  const selectedModifierAsItems = order?.modifiers
    ?.filter((modifier) => modifier.id)

  const nonActiveSelectedModifierAsItemId = requiredItemAsModifier?.find(
    (requiredItem) =>
      selectedModifierAsItems.find(
        (modifierAsItem) => modifierAsItem.item !== selectedItemId
      )?.id === requiredItem.id
  );

  let selectedModifierAsItemsIds = selectedModifierAsItems.map(modifier => modifier.id)

  const pushToItemStack = (item: IKidsComboModifierItem, type: string, isFirstSelection: boolean = false) => {
    item.is_selected = true;
    item.type = type;
    if (isFirstSelection) {
      setItemStack([item])
    }
    else setItemStack([...itemStack, item]);
  };

  const handleItemRemoval = (item, index) => {
    if (!itemStack?.length) return;
    if (isCustomizing)
      setIsCustomizing(false)
    dispatchItem(
      removeTemporarilyAddedPriceForItem({
        price: removeSelectedModifiers(
          modifierGroup?.type,
          index,
          selectedItemId
        ),
        item: selectedItemId,
      })
    );
    if (index === 0)
      dispatchItem(resetComboItemModifiersByItemId({ itemId: selectedItemId - 1 }))
    const updatedItemStack = removeItemFromItemStack(item, itemStack, modifierGroupsQueue)
    setItemStack(updatedItemStack);
  };

  const addItemtoCombo = () => {
    dispatchItem(
      kidsComboItemSelection({ selectedItemId, item: itemStack[0], itemName: CONSTANT.KIDS_COMBO })
    );
    setIsCustomize(false)
    setChosseItem(false);
    const isBothItemSelected = checkIfUserAddAllItems(order)
    isBothItemSelected && dispatchItem(updateAllItemAddedStateForKidsCombo({allItemSelectionState:true}))
  };
  
  const requiredModifiersSelected = selectedIngredients(selectedItemId, CONSTANT.REQUIRED_MODIFIERS)
  const areAllIngredientsSelected = () => {
    if (
      (!modifierGroup.type && itemStack?.length) || // basic item selection case
      requiredModifiersSelected?.length || // required item selected case
      [CONSTANT.ADD_ONS, CONSTANT.COMPLIMENTARY_MODIFIER].includes(
        modifierGroup?.type
      ) // handle complementary step
    ) {
      return true;
    }
    return false;
  };

  if (isCustomizing && !itemStack?.length) {
    const customizedItemStack = getCustomizedItemStack(
      selectedItemId,
      modifierGroupsQueue,
      requiredItemAsModifier,
      selectedModifierAsItems
    );
    setItemStack([...customizedItemStack])
  }


  if (isCustomize !== isCustomizing) {
    selectedModifierAsItemsIds = selectedModifierAsItemsIds.splice(selectedItemId, 1)
  }

  let parentNestedId = null
  const parentItem = itemStack?.at(0)
  if (parentItem?.is_nested_kids_combo) parentNestedId = itemStack?.at(-1)?.id
  const isBasicSelectionOnce = !(itemStack?.length && Object.keys(modifierGroup).length);

  return (
    <div>
      <div className="d-flex flex-wrap gap-3">
        <button
          type="button"
          className={`btn btn-custom back-arrow-btn f-s16 f-sm-s14 px-0 mb-md-3 mb-0 py-0 d-md-flex align-items-center ${kidsComboStyleClasses.hover_color}`}
          onClick={chooseHandleClose}
        >
          Kid’s Combo
        </button>
        {itemStack?.map((selectedItem, index) => {
          return !isBasicSelectionOnce ? (
            <button
              type="button"
              className={`btn btn-custom f-s16 f-sm-s14 px-0 mb-md-3 mb-0 py-0 d-md-flex gap-1 align-items-center clr-dark-blue ${kidsComboStyleClasses.breadcrumb_slash}`}
              onClick={() => handleItemRemoval(selectedItem, index)}
            >
              {`${selectedItem.name}`}
            </button>
          ) : null;
        })}
      </div>
      <hr className="d-md-none d-block" />
      {isItMobile ?
        <Scrollbars
          className={`${kidsComboStyleClasses.item_selection_Scrollbar} mb-mb-4`}
          renderThumbVertical={(props) => (
            <div {...props} className={kidsComboStyleClasses.Scrollbar_thumb} />
          )}
        >
          <ChoseItemModalContent
            itemStack={itemStack}
            modifierGroup={modifierGroup}
            requiredItemAsModifier={requiredItemAsModifier}
            selectedModifierAsItemsIds={selectedModifierAsItemsIds}
            isCustomizing={isCustomizing}
            nonActiveSelectedModifierAsItemId={nonActiveSelectedModifierAsItemId}
            handleItemRemoval={handleItemRemoval}
            pushToItemStack={pushToItemStack}
            modifierGroupsQueue={modifierGroupsQueue}
            selectedItemId={selectedItemId}
            handleIngredientSelection={handleIngredientSelection}
            parentNestedId={parentNestedId}
            orderType={cart?.orderType}
          />
        </Scrollbars>
        :
        <ChoseItemModalContent
          itemStack={itemStack}
          modifierGroup={modifierGroup}
          requiredItemAsModifier={requiredItemAsModifier}
          selectedModifierAsItemsIds={selectedModifierAsItemsIds}
          isCustomizing={isCustomizing}
          nonActiveSelectedModifierAsItemId={nonActiveSelectedModifierAsItemId}
          handleItemRemoval={handleItemRemoval}
          pushToItemStack={pushToItemStack}
          modifierGroupsQueue={modifierGroupsQueue}
          selectedItemId={selectedItemId}
          handleIngredientSelection={handleIngredientSelection}
          parentNestedId={parentNestedId}
          orderType={cart?.orderType}
        />
      }
      <div>
        <hr className="d-md-none d-block mt-5" />
        <ApplyButton
          btnSize="w-50 mt-md-2 mt-0"
          isDisabled={!areAllIngredientsSelected()}
          clickHandle={addItemtoCombo}
          usingIn={CONSTANT.KIDS_COMBO}
        />
      </div>
    </div>
  );
};

export default ChoseItemModal